export default __webpack_public_path__ + "static/media/IF_MyTeamStrengths_StrengthDesc_07.6a01e21f.jpg";